import { render } from "./CreditosDescuentos.vue?vue&type=template&id=b01f5c98"
import script from "./CreditosDescuentos.vue?vue&type=script&lang=js"
export * from "./CreditosDescuentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/CreditosDescuentos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b01f5c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b01f5c98', __exports__)) {
    api.reload('b01f5c98', __exports__)
  }
  
  module.hot.accept("./CreditosDescuentos.vue?vue&type=template&id=b01f5c98", () => {
    api.rerender('b01f5c98', render)
  })

}


export default __exports__